import React from "react";

import { BorderedBlock } from "../../../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { IUser } from "../../../../../../types/user/iuser.interface";
import { UserSearchField } from "../../../../../../features/forms/fields/user-search-field/user-search-field.component";

import { useNdaDependentUsers } from "../../../cb-template/types/cb-template-view.hooks";

import { CbTemplateControlNdaProps } from "./cb-template-control-nda.props";

export const CbTemplateControlNda = (props: CbTemplateControlNdaProps) => {
  const dependentUsers = useNdaDependentUsers(props.isUnderNda);

  const ndaListUserMarkers = (user: IUser) =>
    dependentUsers.filter((dependant) => dependant.id === user.id);

  const ndaListUserReadonly = (user: IUser) =>
    dependentUsers.filter((dependant) => dependant.id === user.id).length > 0;

  return (
    <BorderedBlock showIf={Boolean(props.isUnderNda)}>
      <UserSearchField
        form={props.form}
        label="Allowed viewers"
        name="underNdaUsers"
        required
        userMarkers={ndaListUserMarkers}
        userReadonly={ndaListUserReadonly}
        userPermissions={props.userPermissions}
      />
    </BorderedBlock>
  );
};
